import type { MouseEvent } from 'react';

import { useTrack } from 'src/contexts/AnalyticsContext';
import { Events } from 'src/lib/trackingEvents';

const getLinkText = (anchor: HTMLAnchorElement) => {
  const firstLine = anchor.innerText
    .split('\n')
    .map((line) => {
      return line.trim();
    })
    .find(Boolean);

  return firstLine || anchor.getAttribute('aria-label') || '';
};

const opensOutsideCurrentTab = (
  event: MouseEvent<HTMLElement>,
  anchor: HTMLAnchorElement,
) => {
  return (
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    event.button !== 0 ||
    Boolean(anchor.getAttribute('target'))
  );
};

export const useNavLinkClickTracking = () => {
  const track = useTrack();

  return (event: MouseEvent<HTMLElement>) => {
    if (event.isDefaultPrevented()) {
      return;
    }

    const anchor = (event.target as HTMLElement).closest('a');
    const href = anchor?.getAttribute('href');

    if (
      !anchor ||
      !href ||
      href.startsWith('#') ||
      opensOutsideCurrentTab(event, anchor)
    ) {
      return;
    }

    track({
      type: Events.BUTTON_CLICKED,
      payload: {
        trackingId: Events.BUTTON_CLICKED,
        event: event as MouseEvent<HTMLAnchorElement>,
        currentTarget: anchor,
        buttonName: getLinkText(anchor),
        buttonHref: anchor.href,
        buttonLocation: 'primary_nav',
      },
    });
  };
};
